export const SanitizeEmail = (email) => {
  let [userName, domainName] = email.split("@");
  let firstFour = userName.slice(0, 4);
  let remainingStars = userName.length - firstFour.length;
  let stars = new Array(remainingStars).fill("*").join("");
  return `${firstFour}${stars}@${domainName}`;
};
